import React from 'react';
import { UserPlus, Key, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

export const AdminManagementPanel = ({
  admins = [],
  onCreateAdmin,
  onResetPassword,
  onDeleteAdmin
}) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Admin İdarəetməsi</h2>
        <Button onClick={onCreateAdmin} className="bg-purple-600 hover:bg-purple-700">
          <UserPlus className="h-4 w-4 mr-2" />
          Yeni Admin
        </Button>
      </div>
      
      <Card>
        <CardContent className="p-0">
          <table className="w-full">
            <thead className="bg-zinc-50">
              <tr>
                <th className="text-left p-4">İstifadəçi</th>
                <th className="text-left p-4">Email</th>
                <th className="text-left p-4">Rol</th>
                <th className="text-left p-4">Status</th>
                <th className="text-right p-4">Əməliyyatlar</th>
              </tr>
            </thead>
            <tbody>
              {admins.map(admin => (
                <tr key={admin.id} className="border-t">
                  <td className="p-4">
                    <div>
                      <p className="font-medium">{admin.full_name || admin.username}</p>
                      <p className="text-sm text-zinc-500">@{admin.username}</p>
                    </div>
                  </td>
                  <td className="p-4">{admin.email || '-'}</td>
                  <td className="p-4">
                    <span className={`px-2 py-1 rounded text-xs font-medium ${
                      admin.is_superadmin ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'
                    }`}>
                      {admin.is_superadmin ? 'Super Admin' : 'Admin'}
                    </span>
                  </td>
                  <td className="p-4">
                    <span className={`px-2 py-1 rounded text-xs ${
                      admin.is_active !== false ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                    }`}>
                      {admin.is_active !== false ? 'Aktiv' : 'Deaktiv'}
                    </span>
                  </td>
                  <td className="p-4 text-right">
                    <Button
                      size="sm"
                      variant="outline"
                      className="mr-2"
                      onClick={() => onResetPassword(admin)}
                    >
                      <Key className="h-4 w-4" />
                    </Button>
                    {!admin.is_superadmin && (
                      <Button
                        size="sm"
                        variant="destructive"
                        onClick={() => onDeleteAdmin(admin.id, admin.username)}
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminManagementPanel;
